import React from "react";
import { createPopper } from "@popperjs/core";
import { Link } from "react-router-dom";
import { StatLink } from "../../types/index";

type ActionType = {
	name: string;
	href?: string;
	modal?: boolean;
};

const userActions: ActionType[] = [
	{ name: "Detailed Data", href: "/user/" },
	{ name: "Rentrips Profile", href: "https://rentrips.id/user/" },
	{ name: "Edit User", modal: false },
];

const productActions: ActionType[] = [
	{ name: "Detailed Data", href: "/product/" },
	{ name: "Rentrips Page", href: "https://rentrips.id/listing/" },
	{ name: "Edit Product", modal: false },
];

const blogActions: ActionType[] = [
	{ name: "Edit Blog", href: "/blog/" },
	{ name: "Change Status", modal: false },
];

type DropdownProps = {
	id: string;
	type: StatLink;
};

const defaultProps: DropdownProps = {
	id: "1",
	type: "product",
};

const Dropdown = ({ id, type }: DropdownProps): JSX.Element => {
	const DROPDOWN =
		type === "user"
			? userActions
			: type === "product"
			? type === "product"
				? blogActions
				: productActions
			: [];
	// dropdown props
	const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
	const btnDropdownRef = React.createRef<any>();
	const popoverDropdownRef = React.createRef<any>();
	const openDropdownPopover = () => {
		createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
			placement: "left-start",
		});
		setDropdownPopoverShow(true);
	};
	const closeDropdownPopover = () => {
		setDropdownPopoverShow(false);
	};
	return (
		<div>
			<button
				className="text-blueGray-500 h-8 w-8 rounded-full hover:bg-slate-200 focus:outline-none z-20"
				ref={btnDropdownRef}
				onClick={(e) => {
					dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
					e.stopPropagation();
				}}
			>
				<i className="fas fa-ellipsis-v"></i>
			</button>
			<div
				ref={popoverDropdownRef}
				className={
					(dropdownPopoverShow ? "block " : "hidden ") +
					"bg-white text-base z-50 float-left rounded-lg list-none text-left shadow-xl min-w-48 "
				}
				onClick={(e) => {
					e.stopPropagation();
				}}
			>
				{" "}
				{DROPDOWN.map((action) => {
					if (action.href) {
						if (action.href.startsWith("https")) {
							return (
								<a
									key={action.name}
									href={`${action.href}${id}`}
									rel="noreferrer"
									target="_blank"
									className={
										"text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700 hover:scale-110 hover:bg-sky-200 hover:border-sky-400 rounded-md  hover:border"
									}
								>
									{action.name}
								</a>
							);
						}
						return (
							<Link
								key={action.name}
								to={`${action.href}${id}/info`}
								className={
									"text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700 hover:bg-sky-200 hover:border-sky-400 rounded-md hover:scale-110 hover:border"
								}
							>
								{action.name}
							</Link>
						);
					}
					return (
						<p
							key={action.name}
							className={
								"text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700 hover:scale-110 hover:bg-sky-200 hover:border-sky-400 rounded-md  hover:border"
							}
						>
							{action.name}
						</p>
					);
				})}
				{/* <a
          href="#pablo"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => e.preventDefault()}
        >
          Detailed Data
        </a>
        <a
          href="#pablo"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => e.preventDefault()}
        >
          Rentrips profile
        </a>
        <a
          href="#pablo"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => e.preventDefault()}
        >
          Verify User
        </a>
        <a
          href="#pablo"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => e.preventDefault()}
        >
          Delete User
        </a> */}
			</div>
		</div>
	);
};

Dropdown.defaultProps = defaultProps;

export default Dropdown;
